// Experience Report Teaser

import './index.scss';
import './single-item.scss';
import './sliders-wrapper.scss';

import Swiper, { Navigation, Controller } from 'swiper';

import 'swiper/css';

export default class ExperienceReportTeaser {
  constructor(root) {
    this.root = root;

    const swiperMain = new Swiper(this.root.querySelector('.main-slider'), {
      modules: [Controller],
      slidesPerView: 'auto',
      loop: true,
    });

    const swiperHelp = new Swiper(this.root.querySelector('.help-slider'), {
      modules: [Navigation, Controller],
      slidesPerView: 'auto',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

    swiperMain.controller.control = swiperHelp;
    swiperHelp.controller.control = swiperMain;
  }
}
